export enum DogsAgeType {
  YEARS = 'YEARS',
  BIRTH_DATE = 'BIRTH_DATE',
  LIFE_STAGE = 'LIFE_STAGE',
}
